import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

/**
 * Service to scroll to element.
 *
 * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
 * @export
 */
@Injectable()
export class ScrollToService {

  /**
   * Scroll to element.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof ScrollToService
   */
  public scrollTo(element: string | HTMLElement, duration: number = 500, offset: number = 0): Observable<any> {
    let subject: Subject<any> = new Subject<any>();
    if (typeof element === 'string') {
      let el = document.querySelector(element as string);
      this.scrollToElement(el as HTMLElement, duration, offset, subject);
    } else if (element instanceof HTMLElement) {
      this.scrollToElement(element, duration, offset, subject);
    } else {
      subject.error('I don\'t find element');
    }
    return subject;
  }

  /**
   * Scroll to top of the page.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof ScrollToService
   */
  public scrollToTop(duration: number = 500, offset: number = 0): Observable<any> {
    let subject: Subject<any> = new Subject<any>();
    this.doScrolling(offset, duration, subject);
    return subject;
  }

  // Private methods
  /**
   * Scroll to element.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof ScrollToService
   */
  private scrollToElement(el: HTMLElement, duration: number, offset: number, subject: any) {
    if (el) {
      let viewportOffset = el.getBoundingClientRect();
      let offsetTop = viewportOffset.top + window.pageYOffset;
      this.doScrolling(offsetTop + offset, duration, subject);
    } else {
      subject.error('I don\'t find element');
    }
    return subject;
  }

  /**
   * Do scrolling.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof ScrollToService
   */
  private doScrolling(elementY: any, duration: number, subject: Subject<any>) {
    const startingY = window.pageYOffset;
    const diff = elementY - startingY;
    let start: number;

    window.requestAnimationFrame(function step(timestamp) {
      start = (!start) ? timestamp : start;

      const time = timestamp - start;
      let percent = Math.min(time / duration, 1);

      window.scrollTo(0, startingY + diff * percent);

      if (time < duration) {
        window.requestAnimationFrame(step);
        subject.next({});
      } else {
        subject.complete();
      }
    });
  }
}
